export enum FeatureFlags {
  disableSearchUi = 'search.disableUi',
  disableSearchSpecificDates = 'search.disableSpecificDateSearch',
  disableSearchFlexibleDates = 'search.disableFlexibleDateSearch',
  dreamcatcher = 'homepage.dreamcatcher',
  recommendedForYou = 'homepage.recommendedForYou',
  recentlyViewed = 'homepage.recentlyViewed',
  recentlyViewedSkeletons = 'homepage.recentlyViewedSkeletons',
  collectionPanels = 'homepage.collectionPanels',
  topDestinations = 'homepage.topDestinations',
  editorsPick = 'homepage.editorsPick',
  mobileAds = 'mobile.ads',
  searchKingfisher = 'search.source.kingfisher',
  searchRecommendations = 'search.otherMatches.recommendation',
  searchUpcoming = 'search.otherMatches.upcoming',
  collectionsUpcoming = 'collections.otherMatches.upcoming',
  disableCollectionPageSearch = 'collections.disableSearch',
  cancellationRebooking = 'cancellation.rebooking',
  cancellationAmendments = 'self.serve.rebooking.enabled',
  infoBannerCatalogue = 'homepage.information.banner.catalogue',
  infoBannerNoDeals = 'homepage.information.banner.no.deals',
  warningBanner = 'homepage.warning.banner',
  disableSaleCardUrgency = 'salecard.disableUrgency',
}

export const defaultFeatureFlags: FeatureFlags[] = [
  FeatureFlags.collectionPanels,
  FeatureFlags.dreamcatcher,
  FeatureFlags.recentlyViewed,
  FeatureFlags.topDestinations,
  FeatureFlags.recommendedForYou,
  FeatureFlags.mobileAds,
  FeatureFlags.recentlyViewedSkeletons,
  FeatureFlags.searchRecommendations,
  FeatureFlags.searchUpcoming,
  FeatureFlags.collectionsUpcoming,
  FeatureFlags.infoBannerCatalogue,
  FeatureFlags.warningBanner,
];
